module.exports = __webpack_public_path__ + "img/share_icn.9063e467.svg";